import { ButtonCustom } from "../../../../components/custom/button-custom";
import DateCustomInput from "../../../../components/custom/date-input/date-input-custom";
import { MultiSelectDropdown } from "../../../../components/custom/multi-select-dropdown";
import SearchCustom from "../../../../components/custom/search-custom";
import IconExcelFile from "../../../../components/icons/icon-excel-file";
import { ATTENDANCE_MODE_FILTER_OPTIONS } from "../../../../constants/status";
import { useStoreOptions } from "../../../../hooks/use-store-options";

interface Props {
  dateTime?: string;
  setDateTime?: (time: string) => void;
  fromDate?: string;
  setFromDate?: (date: string) => void;
  toDate?: string;
  setToDate?: (date: string) => void;
  attendanceModes?: number[];
  setAttendanceModes?: (modes: number[]) => void;
  keySearch: string;
  setKeySearch: (value: string) => void;
  branchId: number | "";
  setBranchId: (value: number | "") => void;
  /** "date" = tab "Theo ngày" (mặc định), "month" = tab "Theo tháng". */
  dateType?: "date" | "month";
  isDateRange?: boolean;
  onExportExcel?: () => void;
  loadingExport?: boolean;
}

const AttendanceManagementFilter = ({
  dateTime,
  setDateTime,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  attendanceModes,
  setAttendanceModes,
  keySearch,
  setKeySearch,
  branchId,
  setBranchId,
  dateType = "date",
  isDateRange = false,
  onExportExcel,
  loadingExport = false,
}: Props) => {
  // "Tất cả chi nhánh" (value rỗng, không gửi branch_id) = mọi chi nhánh user đang đăng nhập phụ
  // trách (BE tự resolve qua token.branch_ids), không phải toàn công ty — xem
  // AttendanceRecordSupportService#resolveScopedEmployeeIds.
  const { options: branchOptions, loading: isLoadingBranches } = useStoreOptions();

  return (
    <div
      className="flex flex-wrap items-center justify-between gap-3"
      id="attendance-management-filter"
    >
      <div className="flex flex-wrap items-center gap-2">
        <select
          className="border p-2 rounded-md outline-none bg-white text-sm h-[38px]"
          value={branchId}
          onChange={(e) => setBranchId(e.target.value ? Number(e.target.value) : "")}
          disabled={isLoadingBranches}
        >
          <option value="">Tất cả chi nhánh</option>
          {branchOptions.map((option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>

        {isDateRange ? (
          <div className="flex items-center gap-1.5">
            <DateCustomInput
              type="date"
              value={fromDate}
              maxDate={toDate}
              onChange={(d) => setFromDate?.(d ?? "")}
              placeholder="Từ ngày"
              className="w-[140px]"
            />
            <span className="text-slate-400 font-bold">→</span>
            <DateCustomInput
              type="date"
              value={toDate}
              minDate={fromDate}
              onChange={(d) => setToDate?.(d ?? "")}
              placeholder="Đến ngày"
              className="w-[140px]"
            />
          </div>
        ) : (
          dateTime !== undefined && setDateTime && (
            <DateCustomInput type={dateType} value={dateTime} onChange={setDateTime} />
          )
        )}

        {isDateRange && setAttendanceModes && (
          <MultiSelectDropdown
            placeholder="Chế độ chấm công"
            className="min-w-[210px]"
            dataOptions={ATTENDANCE_MODE_FILTER_OPTIONS}
            optionSelected={ATTENDANCE_MODE_FILTER_OPTIONS.filter((o) => attendanceModes?.includes(o.value))}
            onChange={(selected) => setAttendanceModes(selected.map((o) => Number(o.value)))}
            getOptionLabel={(o) => o.label}
            getOptionKey={(o) => o.value}
          />
        )}
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <SearchCustom value={keySearch} onChange={setKeySearch} />
        {onExportExcel && (
          <ButtonCustom
            text="Xuất excel"
            onClick={onExportExcel}
            icon={<IconExcelFile />}
            isLoading={loadingExport}
            className="font-bold text-green-600 uppercase bg-green-100 hover:bg-green-600 hover:text-white btn"
          />
        )}
      </div>
    </div>
  );
};

export default AttendanceManagementFilter;
